<template>
  <v-app v-if="configLoaded">
    <RouterView />

    <global-snackbar />
  </v-app>
</template>

<script>
import { useUiStore } from '@/stores/ui.js'
import { useLocaleStore } from '@/stores/locale.js'

import Api from '@/api/api.js'
import keycloak from '@/plugins/keycloak.js'

import GlobalSnackbar from '@/components/GlobalSnackbar.vue'

export default {
  components: {
    GlobalSnackbar,
  },

  data () {
    return {
      configLoaded: false,
      configPingInterval: null,
    }
  },

  /**
   * Unfortunately, we shouldn't use well-working .env-files for the app-config
   * and must load that from a public json-file. Since the config is required,
   * we can't start the app without it.
   *
   * @returns {Promise}
   */
  async beforeMount () {
    const res = await fetch('/config.json')

    if (!res.ok) {
      return console.error('could not load client-config.')
    }

    const { backend, oidc } = await res.json()
    Api.baseUrl = `${backend.url}api`
    keycloak.config = oidc

    await useUiStore().getConfig()
    useLocaleStore().initializeFromPath()

    this.configLoaded = true
    this.configPingInterval = setInterval(function () {
      useUiStore().getConfig()
    }, 10000)
  },

  unmounted () {
    clearInterval(this.configPingInterval)
  },
}
</script>

<style lang="scss">
  @import '@/styles/styles.scss';

  .v-main {
    background-color: #f4f6f9;
  }
</style>
